import dataPhotos from '../../../../assets/documents/dataPhotos.png';
import errorModal from '../../../../assets/documents/ErrorIconAfterbanks.png';
import camera from '../../../../assets/documents/camera.png';
import env from '../../../../environment';
import { AutomaticDocumentationNew } from 'mortgage-documents';
import tagSabadell from '../../../../components/tagSabadell';

const AutomaticDocumentation = ({ userMortgageId, stage }) => {
	return (
		<AutomaticDocumentationNew
			userMortgageId={userMortgageId}
			stage={stage}
			env={env}
			platform="sabadell"
			traceSadabdell={tagSabadell}
			images={{
				dataPhotos,
				errorModal,
				camera
			}}
		/>
	);
};

export default AutomaticDocumentation;
